<template>
  <b-row :style="computedStyle">
    <b-col lg="10">
      <b-dropdown
        id="plan-list-dropdown"
        block
        variant="light"
        class="border rounded mt-2"
        toggle-class="d-flex align-items-center w-100 shadow-none"
        menu-class="w-100 p-0"
        :disabled="
          !planList.length ||
          Boolean(planCode) ||
          (!Boolean(planType) && !Boolean(salesRepCode))
        "
      >
        <template #button-content>
          <template v-if="planList.length">
            <span
              class="plan-img d-inline-flex align-items-center justify-content-center border rounded bg-white py-2 px-3 mr-3"
            >
              <img
                :src="computedSelectedPlan.logo"
                class="img-fluid"
                :alt="computedSelectedPlan.name"
                v-if="computedSelectedPlan && computedSelectedPlan.logo"
              />
            </span>
            <span class="text-wrap text-left plan-display pr-3">
              {{ selectedPlanDisplay }}
            </span>
          </template>
          <div v-else class="plan-display w-100 text-center">
            {{ loading ? "Loading..." : "No Plans Available" }}
          </div>
        </template>
        <b-dropdown-item
          v-for="plan in computedPlanList"
          :key="plan.uuid"
          @click="setSelectedPlan(plan)"
          class="plan-item py-2 my-0"
        >
          <div
            class="plan-img d-inline-flex align-items-center justify-content-center border rounded bg-white py-2 px-3 mr-3"
          >
            <img
              :src="plan.logo"
              class="img-fluid"
              :alt="plan.name"
              v-if="plan.logo"
            />
          </div>
          <span class="plan-label">{{ plan.label }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

const currencyFormatter = (value) => {
  if (!value) return "0";

  return Number(parseFloat(value).toFixed(2)).toLocaleString("en", {
    minimumFractionDigits: 2,
  });
};

export default {
  name: "PlanListDropdown",
  props: ["selectedValue"],
  data() {
    return {
      selectedPlan: "tier_0",
    };
  },
  computed: {
    ...mapState("auth", ["planList", "loading"]),
    computedPlanList: {
      get() {
        return this.planList.map((plan) => {
          return {
            ...plan,
            label: `Plan ${currencyFormatter(plan.price)}/month`,
          };
        });
      },
      set(list) {
        return list;
      },
    },
    computedSelectedPlan: {
      get() {
        return this.computedPlanList.find(
          (plan) => plan.code === this.selectedPlan
        );
      },
      set(plan) {
        return plan;
      },
    },
    selectedPlanDisplay: {
      get() {
        return `You've selected the Plan ${
          this.computedSelectedPlan
            ? `${currencyFormatter(this.computedSelectedPlan.price)}/month`
            : ""
        }`;
      },
      set(label) {
        return label;
      },
    },
    planType() {
      return this.$route.query.type;
    },
    salesRepCode() {
      return this.$route.query.sales_rep_code;
    },
    planCode() {
      const paramsPlan = _.get(this.$route, "params.plan");
      const queryPlan = _.get(this.$route, "query.plan");

      if (paramsPlan) return paramsPlan;
      if (queryPlan) return queryPlan;

      return null;
    },
    computedStyle() {
      return {
        "--dropdown-display":
          this.planCode || (!this.planType && !this.salesRepCode)
            ? "none"
            : "block",
        "--dropdown-opacity":
          this.planCode || (!this.planType && !this.salesRepCode) ? 1 : 0.65,
      };
    },
  },
  async created() {
    await this.getPlanList(this.planType ? this.planType : "estore").then(
      () => {
        this.selectedPlan = this.selectedValue;
      }
    );
  },
  methods: {
    ...mapActions({
      getPlanList: "auth/getPlanList",
    }),
    setSelectedPlan(plan) {
      this.selectedPlan = plan.code;
      this.$emit("setSelectedPlan", plan);
    },
  },
  watch: {
    selectedValue(value) {
      this.selectedPlan = value;
    },
  },
};
</script>

<style lang="scss">
#plan-list-dropdown {
  border-radius: 8px !important;
  .dropdown-toggle {
    border-radius: 8px;
    background: #f8f9f9;
    &:hover,
    &:active {
      border-color: transparent;
    }
    &::after {
      position: absolute;
      display: var(--dropdown-display);
      right: 20px;
      border: 0;
      width: 13px;
      height: 7px;
      background: url("~@/assets/images/caret-down.svg") no-repeat center;
    }
    &:disabled {
      opacity: var(--dropdown-opacity);
    }
  }
  .plan-display {
    font-size: 18px;
    font-family: 'SKModernistBold', sans-serif;
    color: #2f3941;
  }
  .plan-img {
    width: 132px;
    height: 70px;
    border-radius: 8px !important;
  }
  .plan-item {
    .dropdown-item {
      display: flex;
      align-items: center;
    }
    .plan-img {
      width: 95px;
      height: 50px;
    }
    .plan-label {
      font-size: 16px;
    }
  }
}
</style>
